import GameBoard from "./components/GameBoard";

const App = () => {
	return (
		<div className="bg-blue-100">
			<GameBoard />
		</div>
	);
};

export default App;
